module.exports = __webpack_public_path__ + "img/mon-6.fa7c78f6.png";